<h3>{{'profit_header' | translate}}</h3>

<app-profits></app-profits>